// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#alcor-collapse .el-collapse-item__header{color:var(--text-default);padding:15px}#alcor-collapse .el-collapse-item__header.is-active{border-radius:10px 10px 0 0}#alcor-collapse .el-collapse-item__wrap{border-radius:0 0 10px 10px;padding:0 15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
